export const DATE_PERIOD = {
  THIS_MONTH: 'this_month',
  LAST_MONTH: 'last_month',
  LAST_YEAR: 'last_year',
  LAST_SIX_MONTHS: 'last_six_months',
  THIS_YEAR: 'this_year',
};

export const DATE_PERIOD_OPERATORS = Object.values(DATE_PERIOD);
